import React from 'react';
import * as signalR from '@microsoft/signalr';
import { useState, useEffect } from "react";
import axios from "../../utils/fvAxios";
import { Backdrop, Box, Stack } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { getOrgId, getOrgType } from "../../utils/Token";
import { ToastContainer, toast } from "react-toastify";
import BaseURL from "../../utils/base-uri.json";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import CircularProgressBar from './CircularProgressBar';

function GenerateCodePop() {
  const toastNotify = (message, isSuccess = true) => {
    if (isSuccess) {
      toast.success(message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  const params = new URLSearchParams(window.location.search);
  const SiteId = params.get("Id");
  const SiteName = params.get("name");

  const [message, setMessage] = useState('');
  const [counter, setCounter] = React.useState("");
  const [spinner, setSpinner] = React.useState(false);
  const OrgId = getOrgId();
  const SpinnerClose = () => {
    setSpinner(false);
  };

  useEffect(() => {
    setSpinner(true);
    axios.get("OnsiteOffsite/GetSiteCheckinCode?clientid=" + OrgId + "&siteid=" + SiteId)
      .then(response => {
        if (response.data.responseCode == 100) {
          // toastNotify(response.data.responseMessage, true);
          setMessage(response?.data?.data);
          setCounter(100);
        } else {
          toastNotify(response.data.responseMessage, false);
        }
      }).catch((error) => {
        console.log(error.response.data);
      }).finally(() => {
        setSpinner(false);
      });

    const connection = new signalR.HubConnectionBuilder()
      .withUrl(BaseURL?.SitecodeupdateURL)
      .build();

    connection.start()
      .then(() => {
        console.log('Connection started');
        connection.invoke("NotifyServer", SiteId)
          .then(id => {
            console.log("ConnectionId is:", id);
          })
      })
      .catch(err => console.log('Error while starting connection: ' + err));
    connection.on('ReceiveNotification', (ReceiveNotification, NotificationTime) => {
      setMessage(ReceiveNotification);
      if (NotificationTime > 1) {
        setCounter(NotificationTime);
      } else {
        setCounter(1);
      }
      console.log(NotificationTime);

    });
  }, []);


  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    // Cleanup listener on component unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  const size = 100;
  const progress = counter;

  const radius = size / 2;
  const angle = (progress / 100) * 360;
  const radian = (angle - 90) * (Math.PI / 180);
  const x = radius + radius * Math.cos(radian);
  const y = radius + radius * Math.sin(radian);
  const largeArcFlag = progress > 50 ? 1 : 0;
  const progressColor = progress >= 90 ? "#E4E7EC" : "#1b9447";


  // const strokeWidth = 12;
  // const circleColor = "#f3f3f3";
  // const progressColor = "#4caf50";
  // const radius = (size - strokeWidth) / 2;
  // const circumference = 2 * Math.PI * radius;
  // const offset = circumference - (progress / 100) * circumference;

  const dummy = 100 - counter
  return (
    <>
      {/* <ToastContainer /> */}
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={spinner}
        onClick={SpinnerClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>


      <div style={{ display: "flow", justifyContent: "center", alignItems: "center", padding: "50px", height: "auto", overflow: "hidden" }}>
        <div className='text-center'>
          <span style={{ fontSize: windowWidth > 768 ? "4rem" : "20px", fontWeight: 600, color: "#3dbfhe" }}>Site name:  </span>  <span style={{ fontSize: windowWidth > 768 ? "4rem" : "20px", fontWeight: 600, color: "#3dbfhe" }}>{SiteName} </span>
        </div>
        <br />

        <Box border={2}
          borderLeft={2}
          borderRight={2}
          borderColor="#e4e7ec" sx={{ padding: "50px", width: "100%" }} className='text-center'>
          <div style={{ display: "flex", justifyContent: "center" }}>
            {/* <CountdownCircleTimer
                isPlaying
                duration={counter}
                colors={'#A30000'}
              colorsTime={0}
              >
                {({ remainingTime }) => remainingTime}
              </CountdownCircleTimer> */}

            <CircularProgressBar progress={dummy} size={150} />

          </div>
          <span style={{ fontSize: windowWidth > 768 ? "6rem" : "20px", fontWeight: 600, color: "#3dbfhe" }}>Check-in code:  </span> <br />

          <span
            style={{
              fontSize: windowWidth > 768 ? "6rem" : "20px",
              fontWeight: 600,

            }}
          >
            {message}
          </span>

        </Box>
      </div >
    </>
  )
}

export default GenerateCodePop